
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/landing",
      function () {
        return require("private-next-pages/[slug]/landing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/landing"])
      });
    }
  